import { combineReducers } from 'redux';
import RolesListReducer from './rolesRequestList-reducer';
import RolesRequestReducer from "./rolesRequest-reducer";
import GroupsRequestListReducer from './groupsRequestList-reducer';
import TrainingsRequestListReducer from './trainingsRequestList-reducer';

const RolesReducer  = combineReducers({
    RolesListReducer,
    GroupsRequestListReducer,
    RolesRequestReducer,
    TrainingsRequestListReducer
});

export default RolesReducer;